<style lang="scss">
.request-wings-page {
  .contact-row-wrapper {
    max-height: 400px;
    overflow: auto;
  }
}
</style>

<!-- eslint-disable -->
<template>
  <div class="col-12 request-wings-page">
    <section class="request-call-page__title mb-3">
      <h2 class="font-weight-bolder mb-2">Request Call - Select Wing</h2>

      <h4>Please select the wing you are currently on</h4>
    </section>

    <section v-if="!loading" class="contact-row-wrapper pr-1 mb-2">
      <div class="contact-row mb-2 d-inline-flex align-items-center full-width pb-1"
           v-for="wing in wings" :key="wing._id">
       <section class="ml-1">
          <h3>{{wing.name}}</h3>
       </section>
        <div class="ui-spacer"></div>
        <b-btn @click="setWing(wing)"
               :variant="isWingSelected(wing) ? 'primary' : 'outline-primary'">
          {{isWingSelected(wing) ? 'Selected' : 'Select'}}
        </b-btn>
      </div>
      <p v-if="wings.length === 0">No wings found</p>
    </section>

    <section v-else>
      <b-spinner variant="primary"></b-spinner>
    </section>

    <section class="d-flex full-width mt-1">
      <b-btn @click="$store.commit('requestCall/SET_STAGE', 1)" variant="outline-primary">Back</b-btn>
      <div class="ui-spacer"></div>
      <b-btn :class="{'disabled': !wingSelected}"
        @click="$store.commit('requestCall/SET_STAGE', 3)" variant="primary">Next</b-btn>
    </section>
  </div>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';

export default {
  name: 'RequestCallWings',
  components: {},
  data() {
    return {
      // eslint-disable-next-line global-require
      loading: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      wingSelected: state => state.requestCall.booking.wing,
      wings: state => state.auth.wings,
    }),
  },
  mounted() {},
  methods: {
    setWing(wing) {
      this.$store.commit('requestCall/SET_WING', wing);
    },
    isWingSelected(wing) {
      // eslint-disable-next-line no-underscore-dangle
      return (this.wingSelected && this.wingSelected._id === wing._id);
    },
  },
}
</script>
